'use client';

import { c as _c } from "react/compiler-runtime";
import { ProposalDetailRight } from '@/components/launchpad/proposal-detail-right';
import { MotionAnimatedAutoHeight } from '@/components/ui/motion-animated-auto-height';
import { SilkSheet } from '@/components/ui/silk-sheet';

// ── Types ────────────────────────────────────────────────────────────────────

type ProposalDisplayStatus = 'active' | 'needs_debate' | 'pending_review' | 'creating' | 'live' | 'rejected' | 'expired';
interface OutcomeItem {
  index: number;
  label: string;
  stakeAmount: string;
  percentage: number;
  backerCount: number;
}
interface UserStakePosition {
  outcomeIndex: number;
  amount: string;
  tokenPrice: string | null;
  tokensReceived: string | null;
}
interface StickyProposalBarProps {
  proposalPubkey: string;
  proposalTitle: string;
  proposalStatus: ProposalDisplayStatus;
  outcomes: OutcomeItem[];
  userStake: {
    positions: UserStakePosition[];
    totalAmount: string;
  } | null;
  isAuthenticated: boolean;
  withdrawFeePercent: number | undefined;
  feeBpsBacking: number | undefined;
  feeBpsUnbacking: number | undefined;
  currentTotalBackedD6: string;
  creationThresholdD6: string | undefined;
  onConnectWallet: () => void;
  /** Sheet visibility — owned by the parent; opened by the hero's mobile
   *  "Back proposal" CTA (`proposal-hero-stake.tsx`). This component has no
   *  trigger of its own. */
  open: boolean;
  onOpenChange: (next: boolean) => void;
  /** The proposal went live and the page is handing off to its market. */
  launching?: boolean;
}

// ── Component ────────────────────────────────────────────────────────────────

/**
 * Mobile/tablet proposal-backing bottom sheet (hidden on desktop, where the
 * sidebar form is shown instead). Purely controlled by the parent.
 */
export function StickyProposalBar(t0) {
  const $ = _c(19);
  const {
    proposalPubkey,
    proposalTitle,
    proposalStatus,
    outcomes,
    userStake,
    isAuthenticated,
    withdrawFeePercent,
    feeBpsBacking,
    feeBpsUnbacking,
    currentTotalBackedD6,
    creationThresholdD6,
    onConnectWallet,
    open,
    onOpenChange,
    launching: t1
  } = t0;
  const launching = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== creationThresholdD6 || $[1] !== currentTotalBackedD6 || $[2] !== feeBpsBacking || $[3] !== feeBpsUnbacking || $[4] !== isAuthenticated || $[5] !== launching || $[6] !== onConnectWallet || $[7] !== outcomes || $[8] !== proposalPubkey || $[9] !== proposalStatus || $[10] !== proposalTitle || $[11] !== userStake || $[12] !== withdrawFeePercent) {
    t2 = <SilkSheet.Body><MotionAnimatedAutoHeight><ProposalDetailRight bare={true} launching={launching} proposalPubkey={proposalPubkey} proposalTitle={proposalTitle} proposalStatus={proposalStatus} outcomes={outcomes} userStake={userStake} isAuthenticated={isAuthenticated} withdrawFeePercent={withdrawFeePercent} feeBpsBacking={feeBpsBacking} feeBpsUnbacking={feeBpsUnbacking} currentTotalBackedD6={currentTotalBackedD6} creationThresholdD6={creationThresholdD6} onConnectWallet={onConnectWallet} /></MotionAnimatedAutoHeight></SilkSheet.Body>;
    $[0] = creationThresholdD6;
    $[1] = currentTotalBackedD6;
    $[2] = feeBpsBacking;
    $[3] = feeBpsUnbacking;
    $[4] = isAuthenticated;
    $[5] = launching;
    $[6] = onConnectWallet;
    $[7] = outcomes;
    $[8] = proposalPubkey;
    $[9] = proposalStatus;
    $[10] = proposalTitle;
    $[11] = userStake;
    $[12] = withdrawFeePercent;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== onOpenChange || $[15] !== open || $[16] !== proposalTitle || $[17] !== t2) {
    t3 = <SilkSheet open={open} onOpenChange={onOpenChange} variant="detached" size="lg" title={proposalTitle} srOnlyHeader={true} closeButton={false}>{t2}</SilkSheet>;
    $[14] = onOpenChange;
    $[15] = open;
    $[16] = proposalTitle;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
}